import { Component, Input, OnInit } from '@angular/core';
import { AuthService, SettingsService } from '../../services';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { LoginModalComponent } from '../../modals/login-modal/login-modal.component';
import { IFeature } from '../../interfaces/landing-feature';

@Component({
    selector: 'app-vesta-root-shell',
    templateUrl: './vesta-root-shell.component.html',
    styleUrls: ['./vesta-root-shell.component.scss']
})
export class VestaRootShellComponent implements OnInit {
    public mailchimpId: string = '';

    @Input() title: string = '';
    @Input() page: 'landing' | 'analysis' | 'marketing' | 'contract' | 'enterprise' = 'landing';
    @Input() isSignupPage: boolean = false;
    @Input() features: IFeature[] = [];

    @Input() showBackButton: boolean = false;
    @Input() showProgressBar: boolean = false;

    public year: number = new Date().getFullYear();
    public isWebsite: boolean = true;
    public price: number = 0;

    constructor(
        public settings: SettingsService,
        public auth: AuthService,
        private location: Location,
        private router: Router,
        private modalCtrl: ModalController,
        private platform: Platform
    ) {
        this.isWebsite = this.platform.platforms().filter(p => p === 'desktop' || p === 'mobileweb').length > 0;
    }

    ngOnInit() {
        switch (this.page) {
            case 'analysis':
                this.price = 5;
                break;
            case 'contract':
                this.price = 99;
                break;
            case 'marketing':
                this.price = 99;
                break;
            case 'enterprise':
                this.price = 199;
                break;
            default:
                this.price = 99;
        }
    }

    back() {
        if (window.history.length > 2) {
            this.location.back();
        } else {
            this.router.navigate(['']);
        }
    }

    async openLoginModal() {
        const modal = await this.modalCtrl.create({
            component: LoginModalComponent,
            componentProps: {
                isLandingPage: true
            },
            cssClass: 'login-modal',
            backdropDismiss: false,
            keyboardClose: false
        });

        await modal.present();

        const { data } =  await modal.onDidDismiss();

        if (data && data.loginSuccessful) {
            if (this.auth.isUserLoggedIn) {
                await this.router.navigate(['/' + this.auth.currentUser.get('organization').id + '/dashboard/properties']);
            } else {
                await this.router.navigate(['/' + this.auth.customerOrganizationId]);
            }
        }
    }
}
